import BookImage from "../../../components/BookImage/BookImage";
import { environment } from "../../../environment"
import { Book as BookModel } from "../../../models/books";
import { LiteraryGenre } from "../../../models/literaryGenre";

import styles from './Book.module.scss';

type Props = Pick<BookModel, 'imageLink' | 'author' | 'page' | 'name'> & {
  genres: LiteraryGenre[]
}

export const BookComponent = ({ imageLink, author, page, name, genres }: Props) => {
  author = Array.isArray(author) ? author.join(', ') : author
  imageLink = imageLink || environment.noCoverBook

  return(
    <div className={styles.container}>
      <section className={styles.containerImage}>
      <BookImage 
        className={styles.image} 
        path={imageLink} 
        author={String(author)}
        name={name}
        />
      </section>
      <section className={styles.containerInfo}>
        <h2><strong>{name}</strong></h2>
        <h3><strong>Autor:</strong> {author}</h3>
        {!!genres?.length && <h2 className={styles.genres}>Gêneros: {genres?.slice(0,4).map(genre => genre.content).join(', ')} ...</h2>} 

        <div className={styles.footerInfo}>
          <span>{page} páginas </span>
        </div>
      </section>
    </div>
  )
}
